import Import from '@core/lib/admin/components/import'
import PropTypes from 'prop-types'
import Complete from './complete'
import React from 'react'

class ContactImport extends React.Component {

  static contextTypes = {
    admin: PropTypes.object,
    modal: PropTypes.object,
    router: PropTypes.object
  }

  static propTypes = {
    program_id: PropTypes.number,
    onBack: PropTypes.func
  }

  _handleCancel = this._handleCancel.bind(this)

  render() {
    return <Import { ...this._getImport() } />
  }

  _getImport() {
    const { program_id, onBack } = this.props
    return {
      sources: ['file'],
      complete: Complete,
      defaults: {
        program_id
      },
      entity: 'user',
      object_type: 'truevail_library_users',
      summary: this._getSummary,
      onBack,
      onCancel: this._handleCancel
    }
  }

  _getSummary(_import) {
    const { channels, lists, tags } = _import.config
    return [
      {
        icon: 'list',
        color: 'teal',
        ...lists && lists.length > 0 ? {
          label: 'Contacts will be subscribed to the following lists',
          items: lists.map(list => list.title)  
        } : {
          label: 'Contacts will be not be subscribed to any lists'
        } 
      },
      {
        svg: 'heart_handshake', 
        color: 'teal',
        ...tags && tags.length > 0 ? {
          label: 'Contacts will be tagged with the following tags',
          items: tags
        } : {
          label: 'Contacts will be not be tagged with any tags'
        } 
      },
      {
        icon: 'list', 
        color: 'teal',
        ...channels && channels.length > 0 ? {
          label: 'Contacts will be opted in to the following channels',
          items: channels
        } : {
          label: 'Contacts will not be opted in to any channels'
        } 
      }
    ]
  }

  _handleCancel() {
    this.context.modal.close()
  }

}

export default ContactImport
